import {
  formatBounceRate,
  formatDateForAPI,
  formatDate,
} from "./methods/formatters";
import { processAnalyticsData } from "./methods/processAnalyticsData";
import { processRealtimeData } from "./methods/processRealtimeData";
import actions from "../../actions";

export const analyticsService = {
  // Format metodları
  formatBounceRate,
  formatDateForAPI,
  formatDate,

  // Veri işleme metodları
  processAnalyticsData,
  processRealtimeData,

  // Yetkilendirme kontrolü
  async checkGoogleAuth(assetId) {
    const result = await actions.analytics.checkGoogleAuth(assetId);
    return result;
  },
  
  // Mülk bağlantısı kontrolü
  async checkPropertyLinked(assetId) {
    const result = await actions.analytics.checkPropertyLinked(assetId);
    return result;
  },

  // Analitik verileri getirme ve işleme
  async getAnalyticsData(assetId, startDate, endDate) {
    const formattedStartDate = startDate ? formatDateForAPI(startDate) : null;
    const formattedEndDate = endDate ? formatDateForAPI(endDate) : null;

    const result = await actions.analytics.fetchAnalyticsData(
      assetId,
      formattedStartDate,
      formattedEndDate
    );

    // Veriyi servis katmanında işleme
    if (result.data) {
      result.processedData = processAnalyticsData(result.data);
    }

    return result;
  },

  // Gerçek zamanlı veri getirme ve işleme
  async getRealtimeData(assetId) {
    const result = await actions.analytics.fetchRealtimeData(assetId);

    // Veriyi servis katmanında işleme
    if (result.data) {
      result.processedData = processRealtimeData(result.data);
    }

    return result;
  },
};
